import React from "react"
import { Redirect } from "react-router-dom"
import { graphql } from "react-apollo"
import { formatRoute } from "../../helpers/sharedHelperFunctions"
import Loading from "../../components/Loading"
import routes from "../../routes"
import gql from "graphql-tag"
import "./DefaultRoute.scss"
import PropTypes from "prop-types"
import LandingPageWithData from "../../components/LandingPage/LandingPageWithData"
import { getEntityTypeMapping } from "../../helpers/sharedHelperFunctions"

const query = gql`
  query DefaultRoute {
    user {
      id
      umbrellaEntity {
        ... on ComplianceEntity {
          id
          name
          __typename
        }
        ... on Network {
          children: facilities {
            id
            managedByCurrentUser
            __typename
          }
          subChildren: departments {
            # edge case, only for users who manage departments across multiple facilities
            id
            __typename
          }
        }
        ... on Facility {
          managedByCurrentUser
          children: departments {
            id
            managedByCurrentUser
            __typename
          }
        }
        ... on Department {
          managedByCurrentUser
        }
      }
    }
  }
`

// This function gets called if a landing page should be shown, and returns the type and IDs of the entities
// that should be shown on the landing page.
const umbrellaEntityToContent = umbrellaEntity => {
  const managedChildren = umbrellaEntity.children.filter(
    child => child.managedByCurrentUser
  )

  const entities = managedChildren.length
    ? managedChildren
    : umbrellaEntity.subChildren

  return {
    childEntityType: getEntityTypeMapping(entities[0].__typename).pluralField,
    childEntityIds: entities.map(entity => entity.id),
  }
}

// If the page should redirect, this returns the route it should redirect to. Otherwise it returns undefined.
const umbrellaEntityToRedirect = umbrellaEntity => {
  if (umbrellaEntity.managedByCurrentUser) {
    const entityTypeMapping = getEntityTypeMapping(umbrellaEntity.__typename)
    return formatRoute(routes.overview, {
      entityType: entityTypeMapping.singularRoute,
      entityId: umbrellaEntity.id,
    })
  }
}

const DefaultRouteContent = props => {
  if (props.data.error) {
    throw props.data.error
  }
  if (props.data.loading) {
    return (
      <div className="DefaultRoute content loading">
        <Loading />
      </div>
    )
  }
  const umbrellaEntity = props.data.user.umbrellaEntity

  const redirect = umbrellaEntityToRedirect(umbrellaEntity)
  if (redirect) return <Redirect to={redirect} />

  const { childEntityType, childEntityIds } = umbrellaEntityToContent(
    umbrellaEntity
  )
  return (
    <div className="DefaultRoute content landing">
      <LandingPageWithData
        entityType={childEntityType}
        entityIds={childEntityIds}
      />
    </div>
  )
}

DefaultRouteContent.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.object,
    user: PropTypes.shape({
      umbrellaEntity: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        __typename: PropTypes.string,
        managedByCurrentUser: PropTypes.bool,
        children: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
          })
        ),
      }),
    }),
  }),
}

const DefaultRoute = graphql(query)(DefaultRouteContent)

export default DefaultRoute
